import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBonusById } from 'core/actions/bonus';
import {
  selectBonusByIdConfig, makeSelectBonusByIdPlacement, makeSelectBonusByIdIsLoaded, makeSelectBonusByIdIsLoading,
} from '../selectors';

export const useGetBonusById = (bonusId) => {
  const dispatch = useDispatch();
  const config = useSelector(selectBonusByIdConfig);

  const selectBonusByIdIsLoading = useMemo(makeSelectBonusByIdIsLoading, []);
  const selectBonusByIdIsLoaded = useMemo(makeSelectBonusByIdIsLoaded, []);
  const selectBonusByIdPlacement = useMemo(makeSelectBonusByIdPlacement, []);

  const isLoading = useSelector(state => selectBonusByIdIsLoading(state, bonusId));
  const isLoaded = useSelector(state => selectBonusByIdIsLoaded(state, bonusId));
  const placement = useSelector(state => selectBonusByIdPlacement(state, bonusId));

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (!isLoading && !isLoaded && bonusId) {
        const { api: { params, options } } = config;

        dispatch(fetchBonusById(bonusId, params, { ...options, namespace: bonusId }));
      }
    }, 10);
    return () => clearTimeout(timerId);
  }, [isLoaded, isLoading, bonusId]);

  return {
    isLoaded,
    isLoading,
    placement,
  };
};
